import React, { Component, ReactNode } from 'react';

class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    try {
      const shopify = (window as any).shopify;
      if (shopify && shopify.loading) shopify.loading(false);
    } catch (_) {
      // The recovery screen must also work if App Bridge is unavailable.
    }
  }

  render() {
    if (this.state.failed) {
      return (
        <div role="alert" style={{ padding: '40px', textAlign: 'center' }}>
          <h1>Advanced Collections couldn’t display this page</h1>
          <p>Reload the app to try again. Any unsaved edits will be lost.</p>
          <button type="button" onClick={() => window.location.reload()}>Reload app</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default AppErrorBoundary;
